import axios from "../_helpers/axiosinstance";
import { getApiEndpoint, Endpoint } from "../nhd-config";

const getEndpoint = () => getApiEndpoint(Endpoint.HazardSearch);

const getUserSavedReports = async () => {
  return await axios.get(`${getEndpoint()}/nhd/api/hazard/saved-reports`);
};

const getCustomReportById = async (id) => {
  // const response = await axios.get("/reports", {});
  // // const data = handleResponse(response);
  // // return data;
  // return response;
  return await axios.get(`${getEndpoint()}/nhd/api/hazard/saved-reports/${id}`);
};

const MyReportsService = {
  getUserSavedReports,
  getCustomReportById,
};

export default MyReportsService;
